
import React, { useEffect, useState } from 'react';
import Header from './header'

import '../scss/zp.scss'

function Zp(props) {



    return (
        <> 
            <Header></Header>
            <div className="box16"></div>
            <div className="box17"></div>
            <div className="box18">
                <img src={require('../imgs/icons7/01.png')} alt=""/>
                <img src={require('../imgs/icons7/02.png')} alt=""/>
                <img src={require('../imgs/icons7/03.png')} alt=""/>
                <img src={require('../imgs/icons7/04.png')} alt=""/>
                <img src={require('../imgs/icons7/05.png')} alt=""/>
                <img src={require('../imgs/icons7/06.png')} alt=""/>
                <img src={require('../imgs/icons7/07.png')} alt=""/>
                <img src={require('../imgs/icons7/08.png')} alt=""/>
                <img src={require('../imgs/icons7/09.png')} alt=""/>
                <img src={require('../imgs/icons7/10.png')} alt=""/>
                <img src={require('../imgs/icons7/11.png')} alt=""/>
                <img src={require('../imgs/icons7/12.png')} alt=""/>
                <img src={require('../imgs/icons7/13.png')} alt=""/>
                <img src={require('../imgs/icons7/14.png')} alt=""/>
                <img src={require('../imgs/icons7/15.png')} alt=""/>
                <img src={require('../imgs/icons7/16.png')} alt=""/>
            </div>
            <div className="box19"></div>
            <div className="box20">
                <div></div>
            </div>
            <div className="box15 "></div>
        </>
    )
}


export default Zp